import type {
  CrmChatProviderKey,
  CrmLeadIntegrationChatTab,
} from '@/api/types/crm/crmLeadFunnels.types'
import type { CrmIntegrationConversation } from '../types/crm-integration-chat.types'

const parseUpdatedAtToUnix = (value: string | null | undefined): number | null => {
  if (!value || typeof value !== 'string') {
    return null
  }
  const ms = Date.parse(value)
  if (!Number.isFinite(ms)) {
    return null
  }
  return Math.floor(ms / 1000)
}

/** Один диалог из crm-integration-chat → вкладка UI чата. */
export const mapCrmIntegrationConversationToChatTab = (
  conversation: CrmIntegrationConversation,
  provider: CrmChatProviderKey,
): CrmLeadIntegrationChatTab | null => {
  const conversationId = Number(conversation.id)
  const integrationId = Number(conversation.integration_id)
  if (
    !Number.isFinite(conversationId) ||
    conversationId <= 0 ||
    !Number.isFinite(integrationId) ||
    integrationId <= 0
  ) {
    return null
  }

  const title =
    typeof conversation.title === 'string' ? conversation.title.trim() || null : null
  const recipient =
    typeof conversation.external_recipient === 'string'
      ? conversation.external_recipient
      : ''

  return {
    id: integrationId,
    integration_id: integrationId,
    conversation_id: conversationId,
    provider: conversation.provider || provider,
    name: title,
    unread_count: Number(conversation.unread_count) || 0,
    last_interaction_at: parseUpdatedAtToUnix(conversation.updated_at),
    recipient,
    attached: true,
    title,
    external_channel_id: conversation.external_channel_id ?? null,
    external_chat_type: conversation.external_chat_type ?? null,
    external_profile_url: null,
  }
}

/** Список диалогов лида → вкладки (без дублей conversation_id). */
export const mapCrmIntegrationConversationsToChatTabs = (
  items: CrmIntegrationConversation[],
  provider: CrmChatProviderKey,
  leadId?: number | null,
): CrmLeadIntegrationChatTab[] => {
  const seen = new Set<number>()
  const tabs: CrmLeadIntegrationChatTab[] = []

  items.forEach((item) => {
    if (provider && item.provider && item.provider !== provider) {
      return
    }
    if (
      leadId != null &&
      Number.isFinite(Number(leadId)) &&
      item.lead_id != null &&
      Number(item.lead_id) !== Number(leadId)
    ) {
      return
    }

    const tab = mapCrmIntegrationConversationToChatTab(item, provider)
    if (tab == null || seen.has(tab.conversation_id)) {
      return
    }
    seen.add(tab.conversation_id)
    tabs.push(tab)
  })

  return tabs
}
